
import Road from "../objects/road";
import Player from "../objects/player";
import SpawnManager from "../managers/SpawnManager";
import Enemy from "../objects/enemy";
import Bullet from "../objects/bullet";
import Loot from "../objects/loot";
import TutorialManager from "../managers/TutorialManager";
import TweenedText from "../objects/text";
import Game from "../game";
import { SDKManager } from "../lib/SDKManager";

export class GameScene extends Phaser.Scene {
  private _road: Road;
  private _player: Player;
  private _spawnManager: SpawnManager;
  private _containers: { [key: string]: Phaser.GameObjects.Container } = {};
  private _tutorialManager: TutorialManager;

  private _slowMoTimer: number = 0;
  private _pointTimer: number = 1;
  private _gameOn: boolean = false;
  private _audio: Array<Phaser.Sound.BaseSound>;
  private _countDown: TweenedText;
  private _countDownTimer: number = 4;
  private _update: Function;
  private _backInAction: TweenedText;

  public game: Game;

  private _updateCounter: number;
  private _updateCounterMax: number;

  constructor() {
    super({
      key: "GameScene"
    });
  }

  init(): void {
    this._containers = {};
    this._player = null;
    this._road = null;
    this._spawnManager = null;
    this._slowMoTimer = 0;
    this._pointTimer = 0;
    this._gameOn = false;
    window.constants["GAME_START"] = this._gameOn;
    this._audio = [];
    this._countDown = null;
    this._countDownTimer = 0;
    this.input.removeAllListeners();
    if (this.input.keyboard) {
      this.input.keyboard.removeAllListeners();
    }

    this._containers["road"] = this.add.container(0, 0);
    this._containers["road"].setDepth(0);
    this._containers["cars_loots"] = this.add.container(0, 0);
    this._containers["cars_loots"].setDepth(1);
    this._containers["player"] = this.add.container(0, 0);
    this._containers["player"].setDepth(2);
    this._containers["overhead"] = this.add.container(0, 0);
    this._containers["overhead"].setDepth(3);

    this._slowMoTimer = 0;

    this._updateCounter = 6;
    this._updateCounterMax = 6;

    this.sound.pauseOnBlur = false;
  }

  create(): void {
    this._gameOn = false;
    window.constants["GAME_START"] = this._gameOn;
    window.constants["GAME_OVER"] = false;
    let boundX = window.constants["CAMERA_BOUND"];
    this.cameras.main.setBounds(boundX, 0, Math.floor(window.constants.SCREEN_WIDTH), window.constants.SCREEN_HEIGHT);
    let parent = document.getElementById("game");
    let ratio = parent.offsetHeight / parent.offsetWidth;
    let height = window.constants.BASE_WIDTH * ratio;

    // create game objects
    // let roadImage = this.textures.getFrame("assets", "road");
    let playerImage = this.textures.getFrame("assets", "player");
    let x = {
      "road": this.cameras.main.width / 2,
      "player": this.cameras.main.width / 2
    },
      y = {
        "road": this.cameras.main.height / 2,
        "player": (window.constants["HD_FLAG"]) ? Math.floor(height - 80 - (playerImage.height * 0.9)) : Math.floor(height - 80 - (playerImage.height * 0.45))
      };
    this._createAnims();
    this._createAudio();
    if (window.constants["MAP"] == 0) {
      this._road = new Road(this, x.road, y.road, window.constants.SCREEN_WIDTH, window.constants.SCREEN_HEIGHT, "assets", 'road');
    } else if (window.constants["MAP"] == 1) {
      this._road = new Road(this, x.road, y.road, window.constants.SCREEN_WIDTH, window.constants.SCREEN_HEIGHT, "desert");
    } else if (window.constants["MAP"] == 2) {
      this._road = new Road(this, x.road, y.road, window.constants.SCREEN_WIDTH, window.constants.SCREEN_HEIGHT, "snow");
    }

    let playerPosY = y.player - 125;
    switch (window.constants["CAR_CHOOSEN"]) {
      case 0:
        this._player = new Player(this, x.player, playerPosY, this._containers["player"], "assets", "player_day");
        break;
      case 1:
        this._player = new Player(this, x.player, playerPosY, this._containers["player"], "car_01");
        break;
      case 2:
        this._player = new Player(this, x.player, playerPosY, this._containers["player"], "car_02");
        break;
      case 3:
        this._player = new Player(this, x.player, playerPosY, this._containers["player"], "car_03");
        break;
      case 4:
        this._player = new Player(this, x.player, playerPosY, this._containers["player"], "car_04");
        break;
      case 5:
        this._player = new Player(this, x.player, playerPosY, this._containers["player"], "car_05");
        break;
      case 6:
        this._player = new Player(this, x.player, playerPosY, this._containers["player"], "car_06");
        break;
    }

    // if (window.constants["MAP"] != 0) {
    //   this._player = new Player(this, x.player, y.player, "assets", "player_day", this._containers["player"]);
    // } else {
    //   this._player = new Player(this, x.player, y.player, "assets", "player", this._containers["player"]);
    // }
    // this._player = new Player(this, x.player, y.player, "player", null, this._containers["player"]);
    this._spawnManager = new SpawnManager(this, this._player, this._containers["cars_loots"], this._containers["overhead"]);
    // let lerpValue = (window.constants["HD_FLAG"])? 0.035 : 1;
    // this.cameras.main.startFollow(this._player, false, lerpValue, 0);
    this._containers["road"].add(this._road);
    this._containers["cars_loots"].add(this._player);
    this._player.setDepth(this._containers["player"].depth + 3);
    this._addCollisionDetection();
    let fontSize = (window.constants["HD_FLAG"]) ? 100 : 30;
    this._countDown = new TweenedText(this, window.constants["BASE_WIDTH"] / 2, window.constants["BASE_HEIGHT"] / 2, "3", null, 1.5, 0.3, { fontSize: fontSize, fontFamily: "font_3" }, 500, Phaser.Math.Easing.Linear, this._onTextTweenEnd.bind(this));
    this._addEventListeners();
    this._startGame();
    let fontSize2 = (window.constants["HD_FLAG"]) ? 40 : 13;
    this._backInAction = new TweenedText(this, window.constants["BASE_WIDTH"] * 0.5, height * 0.4, "BACK IN ACTION", null, 1.5, null, { fontFamily: "font_2", fontSize: fontSize2 }, 1200, Phaser.Math.Easing.Elastic.Out, this._startGame.bind(this));

    this._containers["road"].add(this._road.shadow);
    this._containers["overhead"].add(this._road.overHead);
    if (window.constants["MAP"] != 0) {
      this._containers["overhead"].add(this._road.overHeadShadow);
    }
    this._road.shadow.setDepth(1);
    this._road.overHead.setDepth(3);
    if (window.constants["MAP"] != 0) {
      this._road.overHeadShadow.setDepth(2);
    }
  }

  private _startGame() {
    let x = {
      "road": this.cameras.main.width / 2
    },
      y = {
        "road": this.cameras.main.height / 2
      };
    if (SDKManager.canCheckRoadTexture) {
      // console.log("road texture check");
      SDKManager.canCheckRoadTexture = false;
      if (window.constants["MAP"] == 0) {
        this._road = new Road(this, x.road, y.road, window.constants.SCREEN_WIDTH, window.constants.SCREEN_HEIGHT, "assets", 'road');
      } else if (window.constants["MAP"] == 1) {
        this._road = new Road(this, x.road, y.road, window.constants.SCREEN_WIDTH, window.constants.SCREEN_HEIGHT, "desert");
      } else if (window.constants["MAP"] == 2) {
        this._road = new Road(this, x.road, y.road, window.constants.SCREEN_WIDTH, window.constants.SCREEN_HEIGHT, "snow");
      }

      this._containers["road"].add(this._road);

      this._containers["road"].add(this._road.shadow);
      this._containers["overhead"].add(this._road.overHead);
      if (window.constants["MAP"] != 0) {
        this._containers["overhead"].add(this._road.overHeadShadow);
      }
      this._road.shadow.setDepth(1);
      this._road.overHead.setDepth(3);
      if (window.constants["MAP"] != 0) {
        this._road.overHeadShadow.setDepth(2);
      }
    }
    this._pointTimer = this.time.now;
    window.constants["GAME_OVER"] = false;
    this.game.setRewardStatus(false);
    this._audio[0].play();
    this._countDown.start(null, null, "3");
    this._countDownTimer = 3;
  }

  private _resumeGame() {
    if (this.scene.isPaused("GameScene")) {
      this.scene.resume("GameScene");
    }
    this._cleanUpEndScreen();
    console.log(this.registry.get("points"));
    if (this.game.getRewardStatus()) {
      this._backInAction.start();
    } else {
      this._startGame();
    }
  }

  private _addEventListeners() {
    const scene = this.scene.get("HUDScene");
    scene.events.on("resumeGame", this._resumeGame, this);

    this.events.on("tutorialFailed", this._onTutorialFailure, this);
    this.events.on("gameOver", this._cleanUpEndScreen, this);
  }

  private _cleanUpEndScreen() {
    if (window.constants["TUTORIAL_MODE"]) {
      if (this._tutorialManager) {
        this._tutorialManager.stop();
      }
    }
    this._audio[0].stop();
    this._audio[1].stop();
    this._audio[2].stop();
    this._gameOn = false;
    window.constants["GAME_START"] = this._gameOn;
    this._road.reset();
    this._spawnManager.reset((this.registry.get("points") == 0));
    this._player.reset();
    this.cameras.main.pan(window.constants["BASE_WIDTH"] * 0.5, 0, 100, 'Linear', false);
  }

  private _onTextTweenEnd() {
    this._countDownTimer--;
    if (this._countDownTimer < 1) {
      this._gameOn = true;
      window.constants["GAME_START"] = this._gameOn;
      this._audio[1].play();
      this._road.start();
      this._player.start();
      window.setTimeout(this._spawnManager.start.bind(this._spawnManager), 1000);
      this.input.removeListener("pointerup", this._startGame, this);
      SDKManager.getPlayerFirstTimeMetaData();
      // if (window.constants["TUTORIAL_MODE"] || localStorage.getItem("hammerplay_rampageroad_first") == "true") {
      // // if (window.constants["TUTORIAL_MODE"] || FBInstantManager.isFirstTime == true) {
      // //   if (FBInstantManager.isTournament) {
      // //     FBInstantManager.setPlayerFirstTimeMetaData(false);
      // //     this.events.emit("GameBegin");
      // //     this._update = this._gameUpdate.bind(this);
      // //   } else {
      //     if (!this._tutorialManager) {
      //       this._tutorialManager = new TutorialManager(this, this.scene.get("HUDScene"), this._road, this._player, this._spawnManager, this._onTutorialEnd.bind(this));
      //     }
      //     this._update = this._tutorialManager.update.bind(this._tutorialManager);
      //     window.setTimeout(this._tutorialManager.start.bind(this._tutorialManager), 1000);
      //   // }
      // }
      // else {
      this.events.emit("GameBegin");
      this._update = this._gameUpdate.bind(this);
      // }
    } else {
      this._countDown.start(null, null, Math.floor(this._countDownTimer) + "");
    }
  }

  private _onTutorialEnd() {
    this._spawnManager.reset(true);
    if (window.constants["TUTORIAL_MODE"]) {
      window.constants["TUTORIAL_MODE"] = false;
      this._goToMenuScene();
    } else {
      this._update = this._gameUpdate.bind(this);
      // show pause button
      this.events.emit("GameBegin");
    }
  }

  private _goToMenuScene() {
    this.scene.get("HUDScene").events.emit("gotoMenu");
    // this.scene.sleep("GameScene");
    // this.scene.sleep("HUDScene");
    // this.scene.switch("MenuScene");
  }

  private _onTutorialFailure() {
    this._player.reset();
    this._player.start();
  }

  private _createAudio() {
    this._audio = [];
    this._audio[0] = this.sound.add("ignition", {
      loop: false,
      volume: window.constants["VOLUME"],
    })
    this._audio[1] = this.sound.add("bgm", {
      loop: true,
      volume: window.constants["VOLUME"] * 0.45,
    })
    this._audio[2] = this.sound.add("game_over", {
      loop: false,
      volume: window.constants["VOLUME"],
    })
    this._audio[3] = this.sound.add("explosion", {
      loop: false,
      volume: window.constants["VOLUME"] * 1,
    })
  }

  private _createAnims() {
    this.anims.create({
      key: "explosion_anim",
      frames: this.anims.generateFrameNames("assets", {
        prefix: 'explosion_',
        start: 0,
        end: 15,
      }),
      frameRate: 35,
      repeat: 0,
      hideOnComplete: true,
      showOnStart: true
    })
    this.anims.create({
      key: "coin_flip_anim",
      frames: this.anims.generateFrameNames("assets", {
        prefix: "coin_flip_",
        start: 0,
        end: 3,
      }),
      frameRate: 12,
      repeat: -1,
      hideOnComplete: true,
      showOnStart: true
    })
    this.anims.create({
      key: "warning_anim",
      frames: this.anims.generateFrameNames("assets", {
        prefix: "warning_sheet_",
        start: 0,
        end: 1,
      }),
      frameRate: 8,
      repeat: -1,
      showOnStart: true
    })

    this.anims.create({
      key: "warning_mini_anim",
      frames: this.anims.generateFrameNames("assets", {
        prefix: "warning_mini_",
        start: 0,
        end: 2,
      }),
      frameRate: 5,
      repeat: -1,
      showOnStart: true
    });
    this.anims.create({
      key: "shield_anim",
      frames: this.anims.generateFrameNames("assets", {
        prefix: "shield_",
        start: 0,
        end: 12,
      }),
      frameRate: 14,
      repeat: -1,
      showOnStart: true
    })
    this.anims.create({
      key: "magnet_anim",
      frames: this.anims.generateFrameNames("assets", {
        prefix: "magnet_",
        start: 0,
        end: 5,
      }),
      frameRate: 14,
      repeat: -1,
      showOnStart: true
    })

  }

  private _addCollisionDetection(): void {
    /**
     * player -> enemies
     * player -> obstacles
     * player -> loot
     * player -> enemy bullets
     * player bullets -> enemies
     * player bullets -> obstacles
     * player bullets -> missiles
     */
    let playerBullets = this._player.getBullets();
    let enemyCount = this._spawnManager.enemies.length;
    let lootCount = this._spawnManager.loots.length;
    this.physics.add.overlap(this._player.car, this._spawnManager.obstacles, this._playerHitObstacle, null, this);
    this.physics.add.overlap(this._player.car, this._spawnManager.missiles, this._playerHitObstacle, null, this);

    if (enemyCount && playerBullets) {
      let i = 0;
      while (i < enemyCount) {
        let enemyGroup = this._spawnManager.enemies[i];
        if (enemyGroup.active) {
          this.physics.add.overlap(playerBullets, enemyGroup, this._bulletHitEnemy, null, this);
          this.physics.add.overlap(this._player.car, enemyGroup, this._enemyHitPlayer, null, this);
        }
        i++;
      }
    }

    if (lootCount) {
      let j = 0;
      while (j < lootCount) {
        if (this._spawnManager.loots[j].active) {
          this.physics.add.overlap(this._player.car, this._spawnManager.loots[j], this._playerHitLoot, null, this);
          this.physics.add.overlap(this._player.magnet, this._spawnManager.loots[j], this._magnetHitLoot, null, this);
        }
        j++;
      }
    }

    for (let r = 0, l = this._spawnManager.enemyBullets.length; r < l; r++) {
      this.physics.add.overlap(this._spawnManager.enemyBullets[r], this._player.car, this._bulletHitPlayer, null, this);
    }
  }

  private _bulletHitEnemy(bullet: Bullet, enemy: Enemy): void {
    bullet.stop();
    enemy.hit(bullet.hitValue);
    if (!enemy.visible) {
      this._audio[3].play();
      this._player.setPoints(enemy.bountyValue);
      if (enemy.name == "tank" || enemy.name == "battle_truck") {
        this._emitWreckedCarEvent(enemy.name);
      }
    }
  }

  private _emitWreckedCarEvent(car) {
    let x = 0;
    switch (car) {
      case 'player':
        x = 0;
        break;
      case 'battle_truck':
        x = 1;
        break;
      case 'tank':
        x = 2;
        break;
    }
    this.registry.set('car_wrecked', x);
    this.events.emit("carWrecked");
  }

  private _enemyHitPlayer(player, enemy): void {
    enemy.stop(false, true);
    player.hit(enemy.name, 1);
    this._audio[3].play();
  }

  private _playerHitLoot(player, loot): void {
    if (this._player.magnet.active) {
      loot.hit(player);
    }
    loot.stop();
    // if (loot.tag != 'coin_flip' && loot.tag != 'health') {
    //   this.time.timeScale = 0;
    //   // this._timeScale = 0
    //   this.physics.world.timeScale = 2.5;
    //   this.anims.globalTimeScale = 0;
    //   this.tweens.timeScale = 0.05;
    //   // this.anims.globalTimeScale = 0.5;
    //   this._slowMoTimer = 2000;
    // }
  }

  private _bulletHitPlayer(bullet, player): void {
    bullet.stop();
    this._player.hit(bullet.tag, bullet.hitValue);
  }

  private _playerHitObstacle(player, obstacle): void {
    switch (window.constants["CAR_CHOOSEN"]) {
      case 0:
        player.hit(obstacle.tag, 10);
        break;
      case 1:
        player.hit(obstacle.tag, 11);
        break;
      case 2:
        player.hit(obstacle.tag, 11);
        break;
      case 3:
        player.hit(obstacle.tag, 12);
        break;
      case 4:
        player.hit(obstacle.tag, 12);
        break;
      case 5:
        player.hit(obstacle.tag, 13);
        break;
      case 6:
        player.hit(obstacle.tag, 13);
        break;
    }
    // player.hit(obstacle.tag, 10);
    // console.log(this._player.depth);
  }

  private _playerBulletHitObstacle(bullet, obstacle): void {
    bullet.stop();
  }

  private _magnetHitLoot(magnet, loot: Loot): void {
    loot.moveTowardsTarget(this._player);
  }

  private _gameUpdate(time, delta) {
    this._road.update(time, delta);
    if (this._player.active) {
      this._player.update(time, delta);
      if (!this._updateCounter--) {
        this._updateCounter = this._updateCounterMax;

        this._spawnManager.update(time, delta);
        // this._pointTimer -= delta;
        if (((time - this._pointTimer) * 0.001) >= 1) {
          this._player.setPoints(1);
          this._pointTimer = time;
        }
        if (this.registry.get("health") <= 0 && this._road.move) { // 
          this._player.stop();
          this._road.stop();
          this._spawnManager.stop();
          this._emitWreckedCarEvent(this._player.tag);
          this._audio[1].stop();
          this._audio[2].play();
        }
      }
    }

  }

  update(time, dt: number): void {
    let delta = Math.floor(dt * 10) * 0.0001;
    if (this._gameOn) {
      this._update(time, delta);
    }
  }

  public start() {

  }

  public static calculateHighScore(currentScore: number) {
    SDKManager.getPlayerHighscoreMetaData();
    let highscore = SDKManager.highscore;
    // let highscore = JSON.parse(localStorage.getItem("hammerplay_rampageroad_highscore"));
    if (currentScore > highscore) {
      SDKManager.setPlayerHighscoreMetaData(currentScore);
      // localStorage.setItem("hammerplay_rampageroad_highscore", JSON.stringify(currentScore));
      return currentScore;
    }
    else {
      return highscore;
    }
  }
}
